/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceStatusSrmConnector
 */
export interface DeviceStatusSrmConnector {
    /**
     *
     * @type {number}
     * @memberof DeviceStatusSrmConnector
     */
    connectorIndex?: number;
    /**
     * Corresponds to Connector.ConnectorState
     * @type {string}
     * @memberof DeviceStatusSrmConnector
     */
    simpleConnectorState?: DeviceStatusSrmConnectorSimpleConnectorStateEnum;
    /**
     * Corresponds to Connector.ConnectorStatus
     * @type {string}
     * @memberof DeviceStatusSrmConnector
     */
    state?: string;
    /**
     *
     * @type {number}
     * @memberof DeviceStatusSrmConnector
     */
    transactionId?: number;
}

/**
 * @export
 */
export const DeviceStatusSrmConnectorSimpleConnectorStateEnum = {
    Unknown: "Unknown",
    Available: "Available",
    Preparing: "Preparing",
    Charging: "Charging",
    Discharging: "Discharging",
    Suspended: "Suspended",
    Finishing: "Finishing",
    FullyCharged: "FullyCharged",
    Reserved: "Reserved",
    Unavailable: "Unavailable",
    Faulted: "Faulted",
} as const;
export type DeviceStatusSrmConnectorSimpleConnectorStateEnum =
    (typeof DeviceStatusSrmConnectorSimpleConnectorStateEnum)[keyof typeof DeviceStatusSrmConnectorSimpleConnectorStateEnum];

/**
 * Check if a given object implements the DeviceStatusSrmConnector interface.
 */
export function instanceOfDeviceStatusSrmConnector(
    value: object,
): value is DeviceStatusSrmConnector {
    return true;
}

export function DeviceStatusSrmConnectorFromJSON(
    json: any,
): DeviceStatusSrmConnector {
    return DeviceStatusSrmConnectorFromJSONTyped(json, false);
}

export function DeviceStatusSrmConnectorFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceStatusSrmConnector {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        simpleConnectorState:
            json["simpleConnectorState"] == null
                ? undefined
                : json["simpleConnectorState"],
        state: json["state"] == null ? undefined : json["state"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
    };
}

export function DeviceStatusSrmConnectorToJSON(
    value?: DeviceStatusSrmConnector | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        simpleConnectorState: value["simpleConnectorState"],
        state: value["state"],
        transactionId: value["transactionId"],
    };
}
